var _yup$object;
import * as yup from "yup";
import { AGB, PRIVACY } from "./field-names";
import { AGB_MESSAGE, PRIVACY_MESSAGE } from "../../validation-messages";
export var validationSchema = yup.object((_yup$object = {}, _yup$object[AGB] = yup.boolean().oneOf([true], AGB_MESSAGE), _yup$object[PRIVACY] = yup.boolean().oneOf([true], PRIVACY_MESSAGE), _yup$object));
